export default "__VITE_ASSET__$cyKyXjV__"